import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getCertificationInformationStart,
  getCertificationInformationSuccess,
  getCertificationInformationFailed,
} from "../redux/getCertificationInformation";

import { getCertificationInformationApi } from "core/http/service/personnelInformation";

function* getCertificationInformationWork() {
  try {
    const res = yield call(getCertificationInformationApi);

    yield put({
      type: getCertificationInformationSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getCertificationInformationFailed.type,
    });
  }
}

function* watchGetCertificationInformation() {
  yield takeLatest(
    getCertificationInformationStart.type,
    getCertificationInformationWork
  );
}

export default function* getCertificationInformationSaga() {
  yield all([watchGetCertificationInformation()]);
}
